import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { LazyImage } from 'bv-components';
import { ScrollableContext } from 'bv-contexts';

const BannerImg = ({
  bgUrl,
  textUrl,
  bannerSize,
  bannerIndex,
}) => {
  const scrollableRef = useContext(ScrollableContext);

  return (
    <div className={`bv-slider-item__wrapper bv-slider-item__wrapper--${bannerSize}`}>
      {
        bgUrl && (
          (bannerIndex === 0) ? (
            <picture>
              <source srcSet={bgUrl.replace('default', 'webp').replace(/[^.]+$/, 'webp')} type="image/webp" />
              <img src={bgUrl} alt="banner" className="bv-slider-item__wrapper-bg" />
            </picture>
          ) : (
            <LazyImage
              className="bv-slider-item__wrapper-bg"
              src={bgUrl}
              scrollableRef={scrollableRef}
              webp
            />
          )
        )
      }
      { textUrl && (
        <div className="bv-slider-item__wrapper-text" style={{ backgroundImage: `url("${textUrl}")` }} />
      )}
    </div>
  );
};

BannerImg.propTypes = {
  bgUrl: PropTypes.string,
  textUrl: PropTypes.string,
  bannerSize: PropTypes.string.isRequired,
  bannerIndex: PropTypes.number.isRequired,
};

BannerImg.defaultProps = {
  textUrl: null,
  bgUrl: null,
};

export default BannerImg;
